import { render } from "./Wallet.vue?vue&type=template&id=32053d7b&scoped=true"
import script from "./Wallet.vue?vue&type=script&lang=js"
export * from "./Wallet.vue?vue&type=script&lang=js"

import "./Wallet.vue?vue&type=style&index=0&id=32053d7b&lang=scss&scoped=true"

import exportComponent from "/opt/build/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-32053d7b"]])

export default __exports__